        (function() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            var isInstagram = userAgent.includes('Instagram');
            var isAndroid = /android/i.test(userAgent);
            var isIOS = /iPhone|iPad|iPod/.test(userAgent);
            var searchParams = window.location.search;
            var hasRedirected = searchParams.includes('redirected=true');
            
            // Debug: Log user agent for testing
            console.log('User-Agent:', userAgent);
            console.log('Is Instagram:', isInstagram);
            console.log('Is Android:', isAndroid);
            console.log('Is iOS:', isIOS);
            console.log('Has Redirected:', hasRedirected);
            
            // Clean up the URL if 'redirected=true' is present (post-redirect)
            if (hasRedirected) {
                var cleanSearch = searchParams.replace(/&?redirected=true/, '');
                history.replaceState(null, '', window.location.pathname + (cleanSearch ? cleanSearch : ''));
                return; // Exit to prevent any further action
            }
            
            // Only redirect if in Instagram in-app browser and no loop flag
            if (isInstagram && !hasRedirected) {
                var baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
                var queryString = searchParams ? searchParams + '&' : '?';
                var redirectUrl;
                
                if (isIOS) {
                    // iOS: Use x-safari prefix to force Safari
                    redirectUrl = 'x-safari-' + baseUrl + queryString + 'redirected=true' + window.location.hash;
                } else {
                    // Fallback for other platforms: Simple self-redirect
                    redirectUrl = window.location.href + (searchParams ? '&' : '?') + 'redirected=true';
                }
                
                console.log('Redirecting to:', redirectUrl);
                window.location.href = redirectUrl;
            }
        })();